export enum ÉTAT_VALIDATION_ÉTAPE {
  EN_COURS = 'EnCours',
  A_VALIDER = 'ÀValider',
  VALIDEE = 'Validée',
}
